import Vue from 'vue'
import Router from 'vue-router'
import mixins from '../mixins/minxin'
import {
  Loading
} from 'element-ui'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
Vue.use(Loading);

Vue.use(Router)
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: "/home",
      component: resolve => require(['@/views/index/index'], resolve),
      meta: {
        title: '商城首页'
      },
      children: [{
        path: '/home',
        name: "home",
        component: resolve => require(['@/views/home/index'], resolve),
      },{
        path: '/join',
        name: "join",
        component: resolve => require(['@/views/join/index'], resolve),
      },{
        path: '/classify',
        name: "classify",
        component: resolve => require(['@/views/goods/classify'], resolve),
      },{
        path: '/address',
        name: "address",
        component: resolve => require(['@/views/address/index'], resolve),
      },{
        path: '/delivery/:num',
        name: "delivery",
        component: resolve => require(['@/views/address/delivery'], resolve),
      },{
        path: '/cart',
        name: "cart",
        component: resolve => require(['@/views/goods/cart'], resolve),
      },{
        path: '/goods/confirmOrder',
        name: "detail",
        component: resolve => require(['@/views/goods/confirmOrder'], resolve),
      },
      {
        path: '/goods/detail/:goodsId',
        name: "detail",
        component: resolve => require(['@/views/goods/detail'], resolve),
      },
      // {
      //   path: '/goods/order',
      //   name: "order",
      //   component: resolve => require(['@/views/goods/order'], resolve),
      // },
      {
        path: '/goods/refund',
        name: "refund",
        component: resolve => require(['@/views/goods/refund'], resolve),
      },{
        path: '/info',
        name: "info",
        component: resolve => require(['@/views/info/index'], resolve),
      },{
        path: '/about',
        name: "about",
        component: resolve => require(['@/views/about/index'], resolve),
      },{
        path: '/login',
        name: "login",
        component: resolve => require(['@/views/login/index'], resolve),
      },{
        path: '/apply',
        name: "apply",
        component: resolve => require(['@/views/apply/index'], resolve),
      },{
        path: '/contact',
        name: "contact",
        component: resolve => require(['@/views/contact/index'], resolve),
      },
      {
        path: '/allList',
        name: "allList",
        component: resolve => require(['@/views/allList/index'], resolve),
      },
      {
        path: '/news',
        name: "news",
        component: resolve => require(['@/views/news/index'], resolve),
        meta: {
          title: '商品品牌',
          icon: 'dashboard'
        }
      },
      {
        path: '/news/detail/:id',
        name: "detail",
        component: resolve => require(['@/views/news/detail'], resolve),
      },
      {
        path: '/account',
        name: "account",
        component: resolve => require(['@/views/account/index'], resolve),
      },{
        path: '/message',
        name: "message",
        component: resolve => require(['@/views/message/index'], resolve),
      },{
        path: '/coupon',
        name: "coupon",
        component: resolve => require(['@/views/coupon/index'], resolve),
      },{
        path: '/receive',
        name: "receive",
        component: resolve => require(['@/views/coupon/receive'], resolve),
      },{
        path: '/payment',
        name: "payment",
        component: resolve => require(['@/views/payment/index'], resolve),
      },{
        path: '/order',
        name: "detail",
        component: resolve => require(['@/views/order/index'], resolve),
      },{
        path: '/order/detail/:id',
        name: "detail",
        component: resolve => require(['@/views/order/detail'], resolve),
      }
      
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.fullPath == '/' || to.fullPath == '/home'){
    // router.push("/home")
    // next("/home")
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js